// External link title tag
var LinksExternal = {

	selector: 'a[target="_blank"]',
	pageEditMode: '.pagemode-edit',
	iconExternal: '<span class="icon-external"></span>',

	init: function () {

		if (!$(this.selector).length) return;
		this.addLinkFeautures();
	},
	addLinkFeautures: function () {

		var $externalLink = $(LinksExternal.selector),
			imgButton = "img[src^='/assets/img/icon']",
			imgButtonPlaceholder = "img[src^='/assets/img/styleguide/icon']";

		// remove alt tag from assets icon
		$(imgButton).attr('alt', '');
		$(imgButtonPlaceholder).attr('alt', '');

		$externalLink.each(function () {

			var $thisLink = $(this),
				$thisLinkContentBlock = $thisLink.parents('.content-block'),
				$thisLinkAccordion = $thisLink.parents('.accordion-content'),
				$thisLinkExpander = $thisLink.parents('.expander'),
				$thisLinkBoxwrap = $thisLink.parents('.box-wrap'),
				$thisLinkTimeline = $thisLink.parents('.timeline-wrap'),
				$thisLinkModal = $thisLink.parents('.modal__container'),
				vissuallyHiddenText = '<span class="visually-hidden"> Opens in a new window</span>';

			// remove any existing text
			$thisLink.find('.visually-hidden').remove();

			// add text and remove title attribute if you not are in edit mode in the cms
			if (!$(LinksExternal.pageEditMode).length) {
				$thisLink.append(vissuallyHiddenText);
				$thisLink.removeAttr('title');
			}

			// if the content block has an external link as an image
			$thisLinkContentBlock.each(function () {
				var $this = $(this),
					$linkImg = $this.find('img'),
					$linkWithImage = $linkImg.parent('a');

				// add a class to any link with an image
				$linkWithImage.addClass('link-image');

			});

			// list of external links to exclude
			var listExcluded = $thisLink.is(':not(.list-links__link, .btn, .btn-load-video, .link-image, .social-link, .related-links > li > a)');

			// add title tag only if the link has the following parent's containers 
			if ($thisLinkContentBlock.length || $thisLinkAccordion.length || $thisLinkExpander.length || $thisLinkBoxwrap.length || $thisLinkTimeline.length || $thisLinkModal.length) {

				if (listExcluded) {

					// remove any existing icons
					$thisLink.find('.icon-external').remove();

					// add icon if you are not in the cms
					if (!$(LinksExternal.pageEditMode).length) {
						$thisLink.append(LinksExternal.iconExternal);
					}
				}
			}

		});
	}
};

$(document).ready(function () {
	LinksExternal.init();
});